import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { TraditionalPoliciesRevaluedProduct } from '../financial-insurance-macro-category';

export const traditionalPoliciesRevaluedColumns: Column<TraditionalPoliciesRevaluedProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderCode,
      key: 'code',
      type: 'string',
    },
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
      key: 'newContractCode',
      type: 'string',
    },
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValue,
      key: 'equivalent',
      type: 'amount',
    },
  ];
